import { useEffect, useState } from 'react';

import { SparkMessage } from '../components/SparkMessage';
import { ApiError, listAudit } from '../lib/api';
import type { AuditEntry } from '../lib/types';

/** Root-only view of the security audit trail. */
export function AuditPage() {
  const [entries, setEntries] = useState<AuditEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    listAudit(200)
      .then((result) => {
        if (!cancelled) setEntries(result.entries);
      })
      .catch((err) => {
        if (!cancelled) setError(err instanceof ApiError ? err.message : 'The activity log could not be loaded.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <div className="page-header">
        <div>
          <h1 className="page-header__title">Activity</h1>
          <p className="page-header__subtitle">Sign-in attempts and administrative changes, newest first.</p>
        </div>
      </div>

      {error && <SparkMessage variant="error">{error}</SparkMessage>}

      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th>When</th>
              <th>Event</th>
              <th>Actor</th>
              <th>Detail</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={5} className="table__empty">
                  Loading activity…
                </td>
              </tr>
            )}
            {!loading && entries.length === 0 && (
              <tr>
                <td colSpan={5} className="table__empty">
                  No activity recorded yet.
                </td>
              </tr>
            )}
            {entries.map((entry) => (
              <tr key={entry.id}>
                <td>{new Date(entry.createdAt).toLocaleString()}</td>
                <td className="mono">{entry.event}</td>
                <td className="mono">{entry.actorName || '—'}</td>
                <td>{entry.detail || '—'}</td>
                <td className="mono">{entry.ip || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
